module.exports = __webpack_public_path__ + "static/media/social-error-missing-permissions-es.8bd6940b.png";